export default {
  SPOTIFY_CLIENT_ID: '6b7ddc5726414d27adc6f68d816af4a6'
};
